/**
 * j file open <id>
 * Open file preview URL in browser
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { exec } from 'child_process';
import { ConfigService } from '../../services/config.service.js';
import { FileService } from '../../services/file.service.js';

export function createFileOpenCommand(): Command {
    return new Command('open')
        .description('Open file URL in browser')
        .argument('<id>', 'File ID to open')
        .action(async (id: string) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                const service = new FileService();
                const file = await service.get(config, parseInt(id));

                const url = file.url || file.r2Url;
                console.log(chalk.cyan(`Opening: ${url}`));

                const openCmd = process.platform === 'darwin' ? 'open' : process.platform === 'win32' ? 'start' : 'xdg-open';
                exec(`${openCmd} "${url}"`);

            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
